module.exports = __webpack_public_path__ + "img/paymorrow.7e941469.png";